import { render, staticRenderFns } from "./OutsourceDrushimAreaListItem.vue?vue&type=template&id=dc6da618"
import script from "./OutsourceDrushimAreaListItem.vue?vue&type=script&lang=js"
export * from "./OutsourceDrushimAreaListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports